import { StyleSheet, View } from "react-native"

type ProgressIndicatorProps = {
    total_steps: number,
    step: number,
}

const ProgressIndicator = ({total_steps, step}: ProgressIndicatorProps) => {
    return (
        <View style={{flexDirection:'row', marginBottom: 20}}>
            {
                Array(total_steps).fill(0).map((_, index) => {
                    return (
                        <View style={step >= index ? styles.greenDot :  styles.greyDot}/>
                    )
                })
            }
        </View>
    )
}

const styles = StyleSheet.create({
    greenDot: {
        width: 10,
        height: 10,
        borderRadius: 5,
        backgroundColor: "#006C48",
        marginHorizontal: 8,
    },
    greyDot: {
        width: 10,
        height: 10,
        borderRadius: 5,
        backgroundColor: "#C4C4C4",
        marginHorizontal: 8,
    },
});

export default ProgressIndicator;